<template>
  <div
    class="project-structure-details"
    >
    <div class="project-structure-details-header">
      <slot name="header"/>
    </div>
    <div class="project-structure-details-body">
      <slot name="body"/>
    </div>
  </div>
</template>
<script>
  export default {
    props: [],
    data: () => ({
    }),
  }
</script>
<style>
  .project-structure-details {
    position: relative;
    width: 60vw;
    height: 100%;
    padding: 2px;
  }
  .project-structure-details-header {
    display: flex;
    width: 100%;
    height: 45px;
    align-items: center;
    border-bottom: solid 1px rgb(41,41,41);
    /* margin-bottom: 6px; */
    padding: 3px;
  }
  .project-structure-details-body {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    height: calc(100% - 45px);
    gap: 10px;
    padding: 10px;
  }
</style>
